export type PreviewFileType = 'image' | 'pdf' | 'excel'

export interface PreviewFile {
  url: string
  title: string
  downloadUrl?: string
  type: PreviewFileType
  /** File ID for same-origin fetch (avoids CORS with S3 signed URLs) */
  fileId?: string
  /** File size in bytes (used by Excel viewer for size limit check) */
  fileSize?: number
}

const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'application/svg+xml',
  'image/bmp',
]

const EXCEL_MIME_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
]

export function getPreviewFileType(mimetype: string): PreviewFileType | null {
  if (IMAGE_MIME_TYPES.includes(mimetype)) return 'image'
  if (mimetype === 'application/pdf') return 'pdf'
  if (EXCEL_MIME_TYPES.includes(mimetype)) return 'excel'
  return null
}

export function isPreviewable(mimetype: string): boolean {
  return getPreviewFileType(mimetype) !== null
}
